import React from "react";

const RadioGroup = ({ name, options, value, onChange, className = "" }) => {
  return (
    <div className={`space-y-3 ${className}`}>
      {options.map((option) => (
        <label
          key={option.value}
          className="flex items-start cursor-pointer group"
        >
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={(e) => onChange(e.target.value)}
            className="mt-0.5 h-4 w-4 text-primary focus:ring-2 focus:ring-primary border-neutral-light dark:border-neutral-dark"
          />
          <div className="ml-3">
            <p className="text-sm font-medium text-text dark:text-neutral-light group-hover:text-primary">
              {option.label}
            </p>
            {option.description && (
              <p className="text-sm text-neutral-dark dark:text-neutral-light">
                {option.description}
              </p>
            )}
          </div>
        </label>
      ))}
    </div>
  );
};

export default RadioGroup;
